module.exports = __webpack_public_path__ + "img/simplecoin-big-2.3a496e45.jpg";